import React from 'react';
import { coinValidityDate } from '../utils/coinValidity';
import { PrivateCoinBucket } from '../api/API';

const PrivateCoinExpiry = ({ buckets = [] }: { buckets?: PrivateCoinBucket[] }) => (
  <ul className="private-coin-expiry" aria-label="Private Coin expiration dates">
    {buckets.filter(bucket => bucket.coins_remaining > 0).map(bucket => (
      <li key={bucket.id}>
        {bucket.coins_remaining} PȻ · {bucket.expires_at
          ? `Valid until ${coinValidityDate(bucket.expires_at)}`
          : 'No expiry'}
      </li>
    ))}
  </ul>
);
export default PrivateCoinExpiry;
